/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  SIGNER_PK:
    "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDiJCMYuJV+bvs8GxMaOMFtks+q\nq4S+NWIaTLcGYYd4d/CU2qXsl0Hp6LMRa4bLXJyHbkXTWpLsLqWn/RvKcvYvm9vj\ncJQe2m4tIokcdDnqMPRxSWPG7l4AP0GPV2mLu4fIMuG8YFbzip4yG/28vS72NSB/\ns5ir8R0IyCCHoSDFXQIDAQAB\n-----END PUBLIC KEY-----",
  defaultLoading: {
    image: "https://i.ibb.co/0sLwPKt/Tribe-Footer-removebg-preview.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "Users",
      holders: "Users",
      issuer: "Organization",
    },
    Holders: {
      title: "Users",
    },
    HoldersGroups: {
      title: "Users Group",
    },
    DashboardIssuerAnalysis: {
      title: "Organization",
    },
  },
  googleMap: {
    googleMapApiKey:
      "AIzaSyAPBIZirLOHqJ0QZdHMhgQ8CKfTWtXnPtk" ??
      "AIzaSyCwUwt06Repbrh_9AJK2ZXepGRHIqT9FcY",
  },
  leafletMap: {
    accessKey:
      "pk.eyJ1Ijoia2FsaXJhc3UiLCJhIjoiY2xkYmowN2lhMDEwMjNucng1bWljNjc1byJ9.u1zno72csQKzn-MTwKZoPQ",
  },
  devPublicKey:
    "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCCeNvL99QSY0BGtgL751diUNFS\n1D4D25yjFYaTF7Ru93bvVGBFPkVmkIJeZ6oXCm2QTx7ljEkBYHqJTYJqz+LUnuRH\nHF5AGnGKy/3XtQG6CrBGRl2zVS27LP9C4JMOW69u28L5oEVW6qr52aJwuqPH2aF0\nUZpNKvWAZTsQZF7aZwIDAQAB\n-----END PUBLIC KEY-----",
  stagingPubKey:
    "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCyYxBrJxhFqgeCSrptsJDO+/BN\nl1KqTBCjX7IqRVBlKrAV2B55WzHGEUBfFsxYueoX8hl7A6jGPLptLW0lmAKjlOAA\nYA5i3MTk2nlfBuYIgMX0PwViygLkONCzeDlPlXScC8JhwQnTgCcAr5qAGQPZp+iQ\nao+VJ7jBmh4Z7rq30QIDAQAB\n-----END PUBLIC KEY-----",
  productionPubKey:
    "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDiJCMYuJV+bvs8GxMaOMFtks+q\nq4S+NWIaTLcGYYd4d/CU2qXsl0Hp6LMRa4bLXJyHbkXTWpLsLqWn/RvKcvYvm9vj\ncJQe2m4tIokcdDnqMPRxSWPG7l4AP0GPV2mLu4fIMuG8YFbzip4yG/28vS72NSB/\ns5ir8R0IyCCHoSDFXQIDAQAB\n-----END PUBLIC KEY-----",
};
